<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Listing Category",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Listing Category",
            items: [
               {
                  text: "Listing Category",
                  active: true,
               },                   
            ],


            listing_categories: [],
            listing_category_status: {
               id: "",
               status: "",
            },

            editlisting_category: {
               id: '', 
               title: '',
            },

            listing_length: 10,
            keyword: '',
            status: '',
            errors: {},

            // listing_category: {
            //    id: null,
            //    listing_category : "",
            // },
            
            modal_title: "Edit listing_category",
            button_title: "Save",
         };
      },
      mounted() {
    
      },

      created() {
         this.fetchListingCategory();
      },

      methods: {
         fetchListingCategory(page_url = null) {

         this.getToken();
         let url = "api/admin/listing_category/index?keyword=" + this.keyword + "&limit=" + this.listing_length + "&status=" + this.status;

         page_url = page_url || url;

         if(localStorage.back_url) {
            page_url = localStorage.back_url;  
            localStorage.removeItem('back_url');
         }    

         this.active_page_url = page_url;
            this.loading = true;

            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  if(res.status == 200) {
                     var responseData = res.data.data;
                     console.log(responseData);
                     this.listing_categories = responseData.listing_categories;
                     
                     this.pagination = responseData.listing_categories.links;
                     this.from = responseData.listing_categories.from;
                     this.to = responseData.listing_categories.to;
                     this.total = responseData.listing_categories.total;
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               
            })
            .catch((error) => {
               if (error.response) {
                  if(error.response.status == 422) {               
                     if (error.response.data) {
                        this.errors = error.response.data.message;
                     } 
                     this.$swal("", error.response.statusText, "error");
                     
                  } else if(error.response.status == 500) {
                     this.$swal("", error.response.statusText, "error");

                  } else if(error.response.status == 401) {
                     this.$swal("", error.response.statusText, "error");
                     this.$router.push({ name: "login" });
                     
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", error.message, "error");
               }
            })
            .finally(() => (this.loading = false));
            }, 

            getToken() {
            if (localStorage.getItem('sigofish_admin')) {
               var sigofish_admin =  JSON.parse(localStorage.getItem('sigofish_admin'));
               if(sigofish_admin.token) {
                  this.token = sigofish_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
            },

            showModal(modal) {
            this.$refs[modal].show();
            },

            hideModal(modal) {
               this.$refs[modal].hide();
            },


            activateListingCategory(listing_category) {
            this.activate = false;
            this.$bvModal.msgBoxConfirm('Are you sure you want to publish this listing category?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
            })
            .then(value => {
                  this.activate = value
                  if(this.activate){
                  this.listing_category_status.id = listing_category.id;
                  this.listing_category_status.status = 1;
                  this.updateListingCategoryStatus();
               }
            })
               .catch(err => {
                  console.log(err);
            })
            },
            deactivateListingCategory(listing_category) {
            this.deactivate = false;
            this.$bvModal.msgBoxConfirm('Are you sure you want to unpublish this listing category?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
            })
               .then(value => {
                  this.deactivate = value
                  if(this.deactivate){
                  this.listing_category_status.id = listing_category.id;
                  this.listing_category_status.status = 2;
                  this.updateListingCategoryStatus();
               }
               })
               .catch(err => {
                  console.log(err);
               })
            },

            updateListingCategoryStatus() {

            this.getToken();
            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };
            let url = "api/admin/listing_category/status?id=" + this.listing_category_status.id + "&status=" + this.listing_category_status.status;
            this.$axios
               .get(url, config)
               .then((response) => {                  
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.fetchListingCategory(this.active_page_url);
               })
               .catch((error) => {                
                  if (error.response) {
                     if (error.response.data.message) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               });
            },


            editListingCategory(editlisting_category) {            
            this.modal_title = "Edit listing_category";
            this.button_title = "Save";
            this.editlisting_category.id = editlisting_category.id;
            this.editlisting_category.title = editlisting_category.title; 
            this.edit = true;
            this.showModal("listing-modal");
            },

            addListingCategory() {
               this.getToken();           
               
               const config = {
                  headers: {
                     "Content-type": "multipart/form-data",
                     "Accept": "application/json",
                     "Authorization": "Bearer " + this.token,
                  },
               };

               let url;
               let formData = new FormData();

               if(!this.edit) {
                  // url = "api/admin/add";
                  this.active_page_url = null;

               } else {
                  url = "api/admin/listing_category/edit";
                  formData.append("id", this.editlisting_category.id); 
               }         
               
               formData.append("title", this.editlisting_category.title); 
               // formData.append("description", this.type.description); 

                        
               this.loading = true;
               
               this.$axios
               .post(url, formData, config)
               .then((response) => {
                  if(response.status == 200) {
                     this.$swal("", response.data.message, "success");        
                  }
                     
                  this.hideModal('listing-modal');
                  this.fetchListingCategory(this.active_page_url);
               })
               .catch((error) => {
                  if (error.response) {
                     if(error.response.status == 422) {               
                        if (error.response.data) {
                           this.errors = error.response.data.message;
                        } 
                        this.$swal("", error.response.statusText, "error");
                        
                     } else if(error.response.status == 500) {
                        this.$swal("", error.response.statusText, "error");

                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", error.message, "error");
                  }
               })
               .finally(() => (this.loading = false));
            },
            clearForm() {           
               this.modal_title = "Edit listing_category";
               this.button_title = "Save";
               this.editlisting_category.id = "";
               this.editlisting_category.title = ""; 
               this.edit = false;
               this.errors = {};

            },



         
         // editlisting_category() {            
         //    this.modal_title = "Edit Listing Category";
         //    this.button_title = "Update";
         //    this.listing_category.listing_category = "Today's Deal"; 
              
         //    this.edit = true;
         //    this.showModal("listing_category-modal");
         // },
         // clearForm() {           
            
         //    this.modal_title = "Add Listing Category";
         //    this.button_title = "Add";
         //    this.listing_category.listing_category = "";           
         //    this.edit = false;
         // },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <!----- top button area ends---->

                 

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                               
                           <tr>
                              <th>SI No</th>
                              <th>Listing Category</th>
                              <th>Status</th>
                              <th>Created On</th>
                              <th>Options</th>                              
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(listing_categories)">
                           <tr v-for="(listing_category) in listing_categories" :key="listing_category.id">
                              <td>{{listing_category.id}}</td>  
                              <td>{{listing_category.title}}</td> 
                              <td>
                                 <span v-if="listing_category.status == 1" class="badge rounded-pill bg-success">Active</span>
                                 <span v-if="listing_category.status == 2" class="badge rounded-pill bg-danger">Blocked</span>
                              </td>       
                              <td>{{listing_category.converted_created_at}}</td>
                              <td>
                                 <b-button variant="primary" class="btn btn-sm me-2 mb-2" @click="editListingCategory(listing_category)">Edit</b-button>

                                 <b-button v-if="listing_category.status==1" variant="danger" class="btn-sm mb-2 me-2" @click="deactivateListingCategory(listing_category)">Unpublish</b-button>

                                 <b-button v-else variant="success" class="btn-sm mb-2 me-2" @click="activateListingCategory(listing_category)">Publish</b-button>
                              </td>
                           </tr>

                           <!-- <tr>
                              <td>2</td>  
                              <td>Flash sale</td>  
                              <td>
                                 <span class="badge rounded-pill bg-success">Active</span>
                              </td>                            
                              <td>11 Nov 2021, 04:25 pm</td>
                              <td>
                                 <b-button variant="primary" class="btn btn-sm me-2 mb-2" @click="editlisting_category()">Edit</b-button>
                                 <button class="btn btn-danger btn-sm mb-2" type="button">Unpublish</button>
                              </td>
                           </tr>

                           <tr>
                              <td>3</td>  
                              <td>New Arrival</td>  
                              <td>
                                 <span class="badge rounded-pill bg-success">Active</span>
                              </td>                            
                              <td>11 Nov 2021, 04:25 pm</td>
                              <td>
                                 <b-button variant="primary" class="btn btn-sm me-2 mb-2" @click="editlisting_category()">Edit</b-button>
                                 <button class="btn btn-danger btn-sm mb-2" type="button">Unpublish</button>
                              </td>
                           </tr> -->
                 
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->
                  
                  
                  <!---- modal starts ---->
                  <b-modal ref="listing-modal" id="listing-modal" :title="modal_title" hide-footer @hidden="clearForm()">
                     <b-form @submit.prevent="addListingCategory()">                        
                        <div class="row"> 
                           <b-form-group class="col-lg-12">
                              <label>Title  <span class="text-danger">*</span></label>
                              <b-form-input v-model="editlisting_category.title" :class="{ 'is-invalid': Boolean(errors.title) }"></b-form-input>

                              <div v-for="(val, index) in errors.title" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <b-col md="12" class="mt-3">
                              <b-button type="submit" class="me-3" variant="primary">{{ button_title }}</b-button>
                              <b-button class="" variant="light" @click="hideModal('listing-modal')">Close</b-button>
                           </b-col>
                        </div>                       
                     </b-form>
                  </b-modal>



                  <!-- <b-modal ref="edit-modal" id="edit-modal" title="Edit" hide-footer  @hidden="clearForm()">
                     <b-form @submit.prevent="updateStock()">
                        <b-row>                

                           <b-col lg="12" class="form-group">
                              <label class="control-label">Title <span class="text-danger">*</span></label>
                              <b-form-input type="number" v-model="editlisting_category.title" min="0" v-bind:class="{ 'is-invalid': Boolean(errors.title) }"></b-form-input>
                              <div v-for="(val, index) in errors.title" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                           </b-col>   
                           
                           <b-col lg="12">
                              <b-button type="submit" class="me-3" variant="primary" @click="hideModal('edit-modal')">Update</b-button>
                              <b-button class="" variant="light" @click="hideModal('edit-modal')">Close</b-button>
                           </b-col>
                        </b-row>
                     </b-form>
                  </b-modal> -->
                  <!---- modal ends ----->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
